export default __webpack_public_path__ + "172982b5c4bec420485724877ca94b91.svg";